define('drops/modalAction/modalAction',[
    'jquery',
    'lq/drop',
    'lq/modalblur',
    './ModalActionMpa',
    './ModalActionSpa'
], function ($, Drop, ModalBlur, ModalActionMpa, ModalActionSpa) {
    'use strict';

    var minimumZIndexOfModalLayer = 6000;
    var minimumZIndexOfPopup = 6001;

    var defaults = {
        data: {
            size: { x: 200, y: 80 },
            actionId: '',
            scrolling: 'auto',
            parameters: [],
            eventsToCatch: [],
            opacity: 100,
            lightBoxOpacity: 100,
            animation: 'none',
            minWidth: null,
            minHeight: null,
            color: "rgba(255, 255, 255, 1)",
            hasColor: false,
            useSelectedActionSize: true,
            actionSource: 'selectAction',
            blur: 0,
            boxShadow: {
                enabled: false,
                color: 'rgb(136, 136, 136)',
                x: 0,
                y: 0,
                blur: 0,
                spread: 0
            },
            roundedCorners: {
                enabled: false,
                leftTopRadius: 0,
                rightTopRadius: 0,
                rightBottomRadius: 0,
                leftBottomRadius: 0
            }
        }
    };

    var ModalAction = function (options) {
        Drop.call(this, $('<div class="modal-action" />'), defaults, options);

        this.renderDropShadow();
        this.renderBackground();

        if (this.data.centered) {
            // We set the ModalLayer height explicitly based on the scroll height of the
            // ScrollContainer, but this changes with the window resize
            this.resizer = ModalBlur.updateModalLayerHeight.bind(this);
            $(window).resize(ModalBlur.updateModalLayerHeight.bind(this));
        }
    };

    Drop.extend(ModalAction, Drop);

    ModalAction.typeName = 'ModalAction';

    ModalAction.prototype.preRender = function () {
        this.implementation = this.piping.application.singlePage
            ? new ModalActionSpa(this)
            : new ModalActionMpa(this);
        this.implementation.setUp();

        this.piping.visibility.apply(this);
        this.applyMinimumDimensions();
        this.applyOpacity();
        this.applyPosition();
        this.centerInsideParent();
        this.applyZIndex();
        this.applyAnimation();
        this.applyRoundedCorners();
    };

    ModalAction.prototype.setElementSizeBasedOnAnchoring = function (anchoringData, e) {
        if (anchoringData.top === null ||
            anchoringData.top === undefined ||
            anchoringData.bottom === null ||
            anchoringData.bottom === undefined) {
            this.$element.height(e.sizeY);
        }
        if (anchoringData.left === null ||
            anchoringData.left === undefined ||
            anchoringData.right === null ||
            anchoringData.right === undefined) {
            this.$element.width(e.sizeX);
        }
    };

    ModalAction.prototype.applyRoundedCorners = function () {
        if (this.data.roundedCorners && this.data.roundedCorners.enabled) {
            var radLT = this.data.roundedCorners.leftTopRadius ? (this.data.roundedCorners.leftTopRadius + 0) + 'px' : '0px';
            var radRT = this.data.roundedCorners.rightTopRadius ? (this.data.roundedCorners.rightTopRadius + 0) + 'px' : '0px';
            var radRB = this.data.roundedCorners.rightBottomRadius ? (this.data.roundedCorners.rightBottomRadius + 0) + 'px' : '0px';
            var radLB = this.data.roundedCorners.leftBottomRadius ? (this.data.roundedCorners.leftBottomRadius + 0) + 'px' : '0px';
            this.$element.css({
                borderRadius: radLT + ' ' + radRT + ' ' + radRB + ' ' + radLB
            });
        } else {
            this.$element.css({ borderRadius: '' });
        }
    };

    ModalAction.prototype.applyAnimation = function () {
        if (this.data.animation === 'zoomin') {
            this.$element.addClass('modal-animated-zoomin');
        }
    };

    ModalAction.prototype.applyMinimumDimensions = function () {
        if (this.data.minHeight) {
            this.$element.css('minHeight', this.data.minHeight + 'px');
        }

        if (this.data.minWidth) {
            this.$element.css('minWidth', this.data.minWidth + 'px');
        }
    };

    ModalAction.prototype.applyZIndex = function () {
        this.$element.css('zIndex', minimumZIndexOfPopup + this.data.zIndex);
    };

    ModalAction.prototype.applyOpacity = function () {
        if (this.data.opacity !== 100) {
            this.$element.css('opacity', this.data.opacity / 100);
        }
    };

    ModalAction.prototype.postRender = function () {
        Drop.prototype.postRender.apply(this, arguments);
        this.renderModalLayer(this.data);

        if (this.isVisible()) {
            this.show();
        }

        if (!this.designData) {
            if (this.isScrollable()) {
                this.$scrollContainer
                    .css({
                        overflow: 'auto'
                    })
                    .append(this.$element);
            } else if (this.data.centered) {
                this.$element.appendTo(this.piping.$app);
            }
        }
    };

    ModalAction.prototype.centerInsideParent = function () {
        if (!this.data.centered)
            return;

        if (this.data.top != null || this.data.bottom != null) {
            this.$element
                .css({
                    left: null,
                    right: null,
                    margin: 'auto'
                });

            // the position in this.data is relative to the root drop, but when rendering we have
            // to position the modal relative to the browser window because we're using 'position: fixed'
            if (this.data.top != null)
                this.$element.css('top', this.data.top + (this.getRootDrop().data.top || 0));
            if (this.data.bottom != null)
                this.$element.css('bottom', this.data.bottom + (this.getRootDrop().data.bottom || 0));
        } else {
            this.$element
                .css({
                    top: this.getVerticalCenterPosition() + 'px',
                    bottom: null,
                    left: null,
                    right: null,
                    margin: 'auto'
                });
        }
    };

    ModalAction.prototype.getHorizontalCenterPosition = function () {
        var totalWidth = $(window).width();
        return ((totalWidth - this.data.size.x) / 2) >= 0 ? (totalWidth - this.data.size.x) / 2 : 0;
    };

    ModalAction.prototype.getVerticalCenterPosition = function () {
        var totalHeight = $(window).height();
        return ((totalHeight - this.data.size.y) / 2) >= 0 ? (totalHeight - this.data.size.y) / 2 : 0;
    };

    ModalAction.prototype.renderBackground = function () {
        if (this.data.hasColor)
            this.$element.css({ backgroundColor: this.data.color });
        else
            this.$element.css({ backgroundColor: "transparent" });
    };

    ModalAction.prototype.renderDropShadow = function () {
        if (this.data.boxShadow && this.data.boxShadow.enabled) {
            var color = this.data.boxShadow.color ? this.data.boxShadow.color : 'rgb(136, 136, 136)';
            var x = this.data.boxShadow.x ? (this.data.boxShadow.x + 0) + 'px' : '0px';
            var y = this.data.boxShadow.y ? (this.data.boxShadow.y + 0) + 'px' : '0px';
            var blur = this.data.boxShadow.blur ? (this.data.boxShadow.blur + 0) + 'px' : '0px';
            var spread = this.data.boxShadow.spread ? (this.data.boxShadow.spread + 0) + 'px' : '0px';
            this.$element
                .css({
                    boxShadow:
                        color + ' ' +
                        x + ' ' +
                        y + ' ' +
                        blur + ' ' +
                        spread
                    });
        } else {
            this.$element.css({ boxShadow: '' });
        }
    };

    ModalAction.prototype.show = function () {
        this.implementation.show();

        this.$element.addClass("open");

        Drop.prototype.show.call(this);

        if (this.$scrollContainer) {
            this.$scrollContainer.show();
        }
        if (this.$modalLayer) {
            ModalBlur.updateModalLayerHeight.call(this);
            this.$modalLayer.show();
            this.$modalLayer.removeClass('closed');
        }
        ModalBlur.applyBlur.call(this);

        this.addBackgroundClickHandler();
    };

    ModalAction.prototype.hide = function () {
        this.$element.removeClass("open");

        this.implementation.hide();

        this.removeBackgroundClickHandler();

        Drop.prototype.hide.call(this);

        var self = this;
        setTimeout(function () {
            if (self.$modalLayer) {
                self.$modalLayer.addClass('closed');
                self.$modalLayer.hide();
            }
        });
        if (this.$scrollContainer) {
            this.$scrollContainer.hide();
        }
        if (this.data.hasBlur) {
            ModalBlur.setBlurValue.call(this, 0);
        }
    };

    ModalAction.prototype.addBackgroundClickHandler = function () {
        this.removeBackgroundClickHandler();
        var self = this, openTime = Date.now();
        this.backgroundClickHandler = function (event) {
            if (Date.now() - openTime < 50 || self.$element[0] === event.target || $.contains(self.$element[0], event.target))
                return;

            // e.g. the invisible input element that is used to upload files
            if (!$(event.target).is(':visible'))
                return;

            self.removeBackgroundClickHandler();

            if (self.data.closeWhenBackgroundClicked)
                self.hide();
            self.triggerEventIfEnabled('backgroundClicked');
        };

        this.piping.$app.on('click touchstart', this.backgroundClickHandler);
    };

    ModalAction.prototype.removeBackgroundClickHandler = function () {
        if (this.backgroundClickHandler) {
            this.piping.$app.off('click touchstart', this.backgroundClickHandler);
            this.backgroundClickHandler = null;
        }
    };

    ModalAction.prototype.renderModalLayer = function () {
        if (this.data.hasLightBox || this.data.centered) {
            this.$scrollContainer = this.$scrollContainer || $('<div />').hide();
            this.$modalLayer = this.$modalLayer || $('<div />').appendTo(this.$scrollContainer);

            this.applyModalLayerLayout();

            if (this.data.centered) {
                this.$scrollContainer.appendTo(this.piping.$app);
            } else if (this.data.toBrowser) {
                this.$scrollContainer.appendTo(this.piping.$actionWrapper);
            } else {
                this.$scrollContainer.appendTo(this.rootDrop.$element);
            }
        }
    };

    ModalAction.prototype.applyModalLayerLayout = function () {
        if (this.data.hasLightBox || this.data.centered) {
            this.$scrollContainer
                .css({
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: minimumZIndexOfModalLayer + this.data.zIndex,
                    overflowY: 'hidden'
                });

            this.$modalLayer
                .css({
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: minimumZIndexOfModalLayer + this.data.zIndex - 1,
                    backgroundColor: this.data.hasLightBox ? this.data.lightBoxColor : 'rgba(0, 0, 0, 0)',
                    opacity: this.data.lightBoxOpacity / 100
                });

            if (this.data.animation !== 'none') {
                this.$modalLayer.addClass('modal-animated-modallayer closed');
            }
        }
    };

    ModalAction.prototype.getActionId = function () {
        if (this.data.actionSource === 'fromParameter') {
            var parameterValue = this.piping.parameters.getValue(this.data.actionIdParameter);
            if (parameterValue) {
                return parameterValue;
            }
        }

        return this.data.actionId;
    };

    ModalAction.prototype.getParametersForIframe = function () {
        if (!this.data.parameters)
            return {};

        var self = this;
        var parametersForIframe = {};
        _.each(this.data.parameters, function (parameterName) {
            parametersForIframe[parameterName] = self.piping.parameters.getValue(parameterName);
        });

        return parametersForIframe;
    };

    ModalAction.prototype.triggerEventForChild = function (eventObj) {
        this.implementation.triggerEventForChild(eventObj);
    };

    ModalAction.prototype.isScrollable = function () {
        return this.data.centered && this.$scrollContainer;
    };

    ModalAction.prototype.onError = function (errorArgs) {
        this.implementation.onError(errorArgs);
    };

    ModalAction.prototype.unsubscribeEventHandlers = function () {
        this.removeBackgroundClickHandler();

        if (this.implementation)
            this.implementation.dispose();

        if (this.resizer) {
            $(window).off('resize', this.resizer);
        }

        if (this.$scrollContainer)
            this.$scrollContainer.remove();
    };

    return ModalAction;
});

